import React from 'react'

import { Divider, Label } from 'tools/Uniform'

/*

A table type structure (list of things in columns) where the whole row is an
actionable item.

In the future this can be converted to a grid under the hood, if we so choose,
so that we can use <button> for the ActionTableRow, once grid will suport more
functionality.

<ActionTable>
  <ActionTableHeading>
    <ActionTableHeadCell />
    ...
  </ActionTableHeading>
  <ActionTableBody>
    <ActionTableRow>
      <ActionTableCell />
      ...
    </ActionTableRow>
  </ActionTableBody>
</ActionTable>

import {
  ActionTable as Atable,
  ActionTableBody as Atbody,
  ActionTableCell as Atd,
  ActionTableHeadCell as Ath,
  ActionTableHeading as Athead,
  ActionTableRow as Atr
} from 'tools/Table/Action'

import {
  ActionTable,
  ActionTableBody,
  ActionTableCell,
  ActionTableHeadCell,
  ActionTableHeading,
  ActionTableRow
} from 'tools/Table/Action'

*/

export function ActionTable({
  children,
  className = 'list',
  search = undefined,
  tail = undefined,
  controls = undefined
}) {
  return (
    <>
      {(search || controls) && (
        <div className="flex-items gh3 mb3">
          {search}
          {controls && (
            <div className="ml-auto flex items-center">{controls}</div>
          )}
        </div>
      )}
      <table className={className}>{children}</table>
      {tail && <Divider>{tail !== true && tail}</Divider>}
    </>
  )
}

export function ActionTableHeading({ children }) {
  return (
    <thead>
      <tr>{children}</tr>
    </thead>
  )
}

export function ActionTableHeadCell({
  children,
  className = 'pa2',
  colSpan = undefined
}) {
  return (
    <th className={className} colSpan={colSpan}>
      {children}
    </th>
  )
}

export function ActionTableBody({ children }) {
  return <tbody>{children}</tbody>
}

export function ActionTableRow({
  children,
  color = 'hilite',
  className = '',
  onClick = undefined,
  selected = false,
  disabled = false,
  itemId = undefined,
  ...args
}) {
  if (color === 'accent') {
    throw new Error('oops not supported color=accent')
  }
  const bg = disabled ? 'neutral' : selected ? 'bg-' + color : ''
  const click = onClick ? 'pointer' : 'no-hover'
  return (
    <tr
      {...args}
      className={`${bg} ${click} ${className}`}
      onClick={() => onClick && onClick(itemId)}
    >
      {children}
    </tr>
  )
}

export function ActionTableCell({
  children,
  className = 'pv1 ph2',
  colSpan = undefined,
  onClick = undefined
}) {
  return (
    <td onClick={onClick} className={className} colSpan={colSpan}>
      {children}
    </td>
  )
}

export function EditCell({ label, children, className, flex = false }) {
  return (
    <div className={className}>
      <Label variant="small">{label}</Label>
      {flex ? (
        <div className="flex-items gh3 gv2 w-100">{children}</div>
      ) : (
        children
      )}
    </div>
  )
}

export function EditGrid({ cols = 2, children }) {
  return <div className={`grid cols-${cols} gv3 gh2`}>{children}</div>
}

// no default
